window.addEventListener('load', () => {

  var this_num = $(".p-thumnail__item--active a").attr("data-chara");
  if (typeof this_num === "undefined") {
    this_num = 0;
  }else {
    this_num = this_num - 1;
  }

  var charaThumnail = new Swiper('.p-thumnail__container', {
    containerModifierClass: `p-thumnail__container`,
    wrapperClass: `p-thumnail__wrapper`,
    slideClass: `p-thumnail__item`,
    grabCursor: true,
    freeMode: true,
    slidesPerView: 'auto',
    loop: true,
    loopedSlides: 16,
    loopFillGroupWithBlank: true,
    //loopAdditionalSlides: 100,
    observer: true,
    observeParents: true,
    spaceBetween: -20,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    centeredSlides: true,
    initialSlide:this_num,
    navigation: {
      nextEl: '.js-chara--next',
      prevEl: '.js-chara--prev',
    },
  });
});

//get取得
//--------------------------------------------------------------------
function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

$(document).ready(function() {
  $(".p-chara__navigation--home").click(function(){
    location.href = "./";
  });
  $(".p-thumnail__wrapper").on("click",".js-thumnail a",function(){
    var chara_num = $(this).attr("data-chara");
    location.href = "./" + chara_num + ".php?select=1";
  });

  $('a[href^="#"]').click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, "slow");
    return false;
  });
});

$(window).on('load', function() {
  //初期表示切替
  var select = getParam('select');
  if(select == 1){
    var target = $("#select").offset().top;
    $('html,body').animate({scrollTop: target}, 0);
  }
});
